<div class="d-flex h-100">
  <div *ngIf="link$ | async" class="p-6 m-auto write-review-dialog d-flex flex-column"
       (click)="$event.stopPropagation()">
    <em (click)="this.launchDialogService.closeDialog('Dialog close')"
        (keyup.enter)="this.launchDialogService.closeDialog('Dialog close')"
        [tabindex]="0"
        class="ds-icon ds-icon--close close-button focusable focusable__element ms-auto">
    </em>
    <div class="d-flex flex-row justify-content-center align-items-center">
      <img
        [alt]="'productReview.chatBubbleOrange' | cxTranslate"
        class="chat-bubble-orange img-responsive center-block mx-auto"
        src="/assets/images/product/chat-bubble-icon-orange.svg"/>
    </div>
    <h2 class="text-center ds-heading--m mt-5 mb-4">
      {{headlineText$ | async}}
    </h2>
    <p class="ds-body--l text-center mb-5">
      {{'productReview.G2CrowdRedirect' | cxTranslate}}
    </p>
    <div class="text-center">
      <a [href]="link$ | async"
         dcpAutofocus
         class="btn btn-primary"
         id="review-write-a-review-g2-com-link"
         rel="noopener noreferrer"
         target="_blank">
        {{'productReview.continueToG2Crowd' | cxTranslate}}
      </a>
    </div>
  </div>
</div>
